<div class="org-inactive-backdrop" *ngIf="state$ | async as state" role="dialog" aria-modal="true"
     aria-labelledby="org-inactive-title">
  <div class="org-inactive-dialog">
    <div class="org-inactive-header">
      <div class="org-inactive-icon"><i class="fa fa-ban"></i></div>
      <div>
        <h5 class="org-inactive-title" id="org-inactive-title">Organization inactive</h5>
        <div class="org-inactive-subtitle">{{ state.orgName }}</div>
      </div>
    </div>

    <div class="org-inactive-body">
      <p class="org-inactive-message">
        Your access to <strong>{{ state.orgName }}</strong> is no longer active.
        Please contact your administrator if you need access again.
      </p>

      <div class="org-inactive-loading" *ngIf="state.loading">
        <i class="fa fa-spinner fa-spin"></i> Checking your other organizations…
      </div>

      <ng-container *ngIf="!state.loading">
        <ng-container *ngIf="state.orgs.length; else noOrgs">
          <div class="org-inactive-section-label">Switch to another organization</div>
          <button type="button" class="org-inactive-org" *ngFor="let org of state.orgs"
                  [disabled]="!!state.switchingTo" (click)="switchTo(org)">
            <span class="org-inactive-org-icon"><i class="fa fa-building"></i></span>
            <span class="org-inactive-org-text">
              <span class="org-inactive-org-name">{{ org.name }}</span>
              <span class="org-inactive-org-role" *ngIf="org.role">{{ formatRole(org.role) }}</span>
            </span>
            <span class="org-inactive-org-action">
              <i class="fa" [ngClass]="state.switchingTo === org.id ? 'fa-spinner fa-spin' : 'fa-arrow-right'"></i>
            </span>
          </button>
        </ng-container>
        <ng-template #noOrgs>
          <div class="org-inactive-empty">You have no other active organization.</div>
        </ng-template>
      </ng-container>

      <div class="org-inactive-error" *ngIf="state.error">{{ state.error }}</div>
    </div>

    <div class="org-inactive-footer">
      <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="!!state.switchingTo" (click)="logout()">
        <i class="fa fa-sign-out mr-1"></i> Log out
      </button>
    </div>
  </div>
</div>
